export default __webpack_public_path__ + "static/media/cosmic-masque-issue-17.fc9d9f22.jpg";